export default __webpack_public_path__ + "static/media/settings.6567c0df.svg";